<section class="lp-countries-hero-jumbotron">
  <div class="row">
    <div class="col-12">
      <h2 class="shop-and-ship-page-section-title">How It Works - Shop the World, Deliver to <span *ngIf="activeCountry?.country_name === 'United States of America' || activeCountry?.country_name === 'United Kingdom'"> the </span>{{activeCountry?.country_name}}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="shop-and-ship-why-choose-shippn-wrapper">
        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/shopping-destination.png"
            alt=""
          />
          <strong>Choose Your Shopping Destination</strong>
          <p>
            Select from 36+ countries including <span *ngIf="activeCountry?.country_route !== 'united-states-of-america'">the USA</span> <span *ngIf="activeCountry?.country_route === 'united-states-of-america'">France</span>, <span *ngIf="activeCountry?.country_route !== 'united-kingdom'">the UK</span> <span *ngIf="activeCountry?.country_route === 'united-kingdom'">Canada</span>, <span *ngIf="activeCountry?.country_route !== 'japan'">Japan</span> <span *ngIf="activeCountry?.country_route === 'japan'">Singapore</span>, <span *ngIf="activeCountry?.country_route !== 'germany'">Germany</span> <span *ngIf="activeCountry?.country_route === 'germany'">Netherlands</span>, <span *ngIf="activeCountry?.country_route !== 'italy'">Italy</span> <span *ngIf="activeCountry?.country_route === 'italy'">Spain</span> and more. Whatever you want to buy, we've got you covered!
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/get-free-address.png"
            alt=""
          />
          <strong>Get Your Free International Address</strong>
          <p>
            Sign up with Shippn and instantly receive free shipping addresses in your chosen countries. Use these addresses when shopping online as if you were a local customer.
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/without-limitations.png"
            alt=""
          />
          <strong>Shop Without Limitations</strong>
          <p>
            Browse and buy from any international retailer - even those that don't ship internationally. No foreign payment methods required!
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/handle-everything-else-and-ship.png"
            alt=""
          />
          <strong>We Handle Everything Else</strong>
          <p>
            Once your purchases arrive at our international address, we'll prepare, consolidate, and ship them directly to your home in <span *ngIf="activeCountry?.country_name === 'United States of America' || activeCountry?.country_name === 'United Kingdom'"> the </span>{{activeCountry.country_name}} with full tracking.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
